// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a9a56aa9","885":"d2af4bff"}[chunkId] + ".chunk.js";
};